module.exports = __webpack_public_path__ + "img/down.44a090d2.svg";